var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{key:"loading",staticClass:"loading"},[_vm._t("loading")],2):_c('div',{key:"content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }